// Export an array of topics for VA 1st Grade Math
const va3rdMathQuizContent = [
  {
    "slug": "greaterthanlessthan",
    "title": "Greater Than Less Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which is greater: 8 ___ 5?",
        "answers": [
          { "text": "8 > 5", "correct": true },
          { "text": "8 < 5", "correct": false },
          { "text": "8 = 5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which is less: 3 ___ 7?",
        "answers": [
          { "text": "3 < 7", "correct": true },
          { "text": "3 > 7", "correct": false },
          { "text": "3 = 7", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which statement is true?",
        "answers": [
          { "text": "9 > 4", "correct": true },
          { "text": "9 < 4", "correct": false },
          { "text": "9 = 4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which statement shows equal numbers?",
        "answers": [
          { "text": "6 = 6", "correct": true },
          { "text": "6 > 6", "correct": false },
          { "text": "6 < 6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which side of the symbol faces the greater number?",
        "answers": [
          { "text": "The open side", "correct": true },
          { "text": "The closed side", "correct": false },
          { "text": "Both sides are equal", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "fractiondefinitions",
    "title": "Fraction Definitions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a fraction?",
        "answers": [
          { "text": "A part of a whole", "correct": true },
          { "text": "A whole number", "correct": false },
          { "text": "A type of shape", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the denominator tell us?",
        "answers": [
          { "text": "How many parts the whole is divided into", "correct": true },
          { "text": "How many parts we have", "correct": false },
          { "text": "The size of the parts", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the numerator tell us?",
        "answers": [
          { "text": "How many parts we have", "correct": true },
          { "text": "How many parts make the whole", "correct": false },
          { "text": "The size of each part", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which number is on the top of a fraction?",
        "answers": [
          { "text": "Numerator", "correct": true },
          { "text": "Denominator", "correct": false },
          { "text": "Whole number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which number is on the bottom of a fraction?",
        "answers": [
          { "text": "Denominator", "correct": true },
          { "text": "Numerator", "correct": false },
          { "text": "Equal sign", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "addsubtractfractionscommon",
    "title": "Add & Subtract Fractions Common",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What stays the same when adding fractions with the same denominators?",
        "answers": [
          { "text": "The denominator", "correct": true },
          { "text": "The numerator", "correct": false },
          { "text": "The whole number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is 2/6 + 3/6?",
        "answers": [
          { "text": "5/6", "correct": true },
          { "text": "6/12", "correct": false },
          { "text": "1/6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is 5/8 - 2/8?",
        "answers": [
          { "text": "3/8", "correct": true },
          { "text": "7/8", "correct": false },
          { "text": "5/16", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When adding 1/4 + 2/4, what is the sum?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "1/2", "correct": false },
          { "text": "2/8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To subtract 7/10 - 3/10, what should you do?",
        "answers": [
          { "text": "Subtract the numerators and keep the denominator", "correct": true },
          { "text": "Subtract both numerators and denominators", "correct": false },
          { "text": "Change the denominator", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "comparefractions",
    "title": "Compare Fractions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which fraction is greater: 3/4 or 1/4?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "1/4", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which fraction is less: 2/8 or 6/8?",
        "answers": [
          { "text": "2/8", "correct": true },
          { "text": "6/8", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which pair of fractions are equal?",
        "answers": [
          { "text": "1/2 and 2/4", "correct": true },
          { "text": "1/3 and 2/3", "correct": false },
          { "text": "1/4 and 3/4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When fractions have the same denominator, how do you compare them?",
        "answers": [
          { "text": "Compare the numerators", "correct": true },
          { "text": "Compare the denominators", "correct": false },
          { "text": "Add them together", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which is greater: 2/3 or 2/6?",
        "answers": [
          { "text": "2/3", "correct": true },
          { "text": "2/6", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "dollarsandcents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many cents are in one dollar?",
        "answers": [
          { "text": "100", "correct": true },
          { "text": "50", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many nickels make one dollar?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "10", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many dimes are in one dollar?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "5", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many quarters equal one dollar?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "10", "correct": false },
          { "text": "2", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which president is on the penny?",
        "answers": [
          { "text": "Abraham Lincoln", "correct": true },
          { "text": "George Washington", "correct": false },
          { "text": "Thomas Jefferson", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "tellingtime",
    "title": "Telling Time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the little hand on a clock show?",
        "answers": [
          { "text": "The hour", "correct": true },
          { "text": "The minutes", "correct": false },
          { "text": "The seconds", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the big hand on a clock show?",
        "answers": [
          { "text": "The minutes", "correct": true },
          { "text": "The hour", "correct": false },
          { "text": "The day", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the little hand is on 3 and the big hand is on 12, what time is it?",
        "answers": [
          { "text": "3:00", "correct": true },
          { "text": "12:30", "correct": false },
          { "text": "3:30", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the big hand points to the 3, how many minutes have passed?",
        "answers": [
          { "text": "15 minutes", "correct": true },
          { "text": "10 minutes", "correct": false },
          { "text": "20 minutes", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the big hand points to the 6, what does that mean?",
        "answers": [
          { "text": "30 minutes past the hour", "correct": true },
          { "text": "10 minutes past the hour", "correct": false },
          { "text": "5 minutes past the hour", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "elapsedtime",
    "title": "Elapsed Time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. If school starts at 8:00 AM and ends at 2:00 PM, how long is the school day?",
        "answers": [
          { "text": "6 hours", "correct": true },
          { "text": "5 hours", "correct": false },
          { "text": "7 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If a movie begins at 3:00 PM and ends at 5:30 PM, how long is the movie?",
        "answers": [
          { "text": "2 hours 30 minutes", "correct": true },
          { "text": "2 hours", "correct": false },
          { "text": "3 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you start your homework at 6:15 PM and finish at 7:00 PM, how much time passed?",
        "answers": [
          { "text": "45 minutes", "correct": true },
          { "text": "30 minutes", "correct": false },
          { "text": "1 hour", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If a train leaves at 9:00 AM and arrives at 11:45 AM, what is the elapsed time?",
        "answers": [
          { "text": "2 hours 45 minutes", "correct": true },
          { "text": "3 hours", "correct": false },
          { "text": "2 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If lunch starts at 12:00 PM and ends at 12:30 PM, how long is lunch?",
        "answers": [
          { "text": "30 minutes", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "45 minutes", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "lines",
    "title": "Lines",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a line?",
        "answers": [
          { "text": "A straight path that extends in both directions", "correct": true },
          { "text": "A path that starts and stops at one point", "correct": false },
          { "text": "A curved path that loops", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are perpendicular lines?",
        "answers": [
          { "text": "Two lines that intersect to form right angles", "correct": true },
          { "text": "Lines that never meet", "correct": false },
          { "text": "Lines that run side by side", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are parallel lines?",
        "answers": [
          { "text": "Lines that never intersect", "correct": true },
          { "text": "Lines that cross at one point", "correct": false },
          { "text": "Lines that make a 90° angle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is a ray?",
        "answers": [
          { "text": "A line that starts at one endpoint and goes on forever", "correct": true },
          { "text": "A line that has two endpoints", "correct": false },
          { "text": "Two lines that cross each other", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is a line segment?",
        "answers": [
          { "text": "Part of a line with two endpoints", "correct": true },
          { "text": "A line that goes on forever", "correct": false },
          { "text": "Two lines that form right angles", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "polygons",
    "title": "Polygons",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a polygon?",
        "answers": [
          { "text": "A closed, two-dimensional shape made of straight lines", "correct": true },
          { "text": "A shape made of curves", "correct": false },
          { "text": "A solid, three-dimensional figure", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How do polygons get their names?",
        "answers": [
          { "text": "By the number of sides and angles they have", "correct": true },
          { "text": "By their color", "correct": false },
          { "text": "By their size", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a pentagon have?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does an octagon have?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "7", "correct": false },
          { "text": "9", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "shapes",
    "title": "Shapes",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a rectangle have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "3", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a square have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a pentagon have?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does an octagon have?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "6", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "quadrilaterals",
    "title": "Quadrilaterals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a quadrilateral?",
        "answers": [
          { "text": "A polygon with four sides", "correct": true },
          { "text": "A polygon with three sides", "correct": false },
          { "text": "A shape with five sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a quadrilateral have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "3", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes a rectangle a quadrilateral?",
        "answers": [
          { "text": "It has four right angles and opposite sides equal", "correct": true },
          { "text": "It has all sides equal but no right angles", "correct": false },
          { "text": "It has only three sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes a square different from a rectangle?",
        "answers": [
          { "text": "All four sides of a square are equal", "correct": true },
          { "text": "A square has only one pair of parallel sides", "correct": false },
          { "text": "A square has no right angles", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What defines a parallelogram?",
        "answers": [
          { "text": "A shape with two pairs of parallel sides", "correct": true },
          { "text": "A shape with three equal sides", "correct": false },
          { "text": "A shape with all right angles", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "pictograph",
    "title": "Pictograph",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a pictograph?",
        "answers": [
          { "text": "A chart that uses pictures or symbols to show data", "correct": true },
          { "text": "A graph that uses bars to show numbers", "correct": false },
          { "text": "A graph that shows data with lines", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does each picture or symbol in a pictograph represent?",
        "answers": [
          { "text": "An amount of data", "correct": true },
          { "text": "A color in the graph", "correct": false },
          { "text": "A shape with sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the key in a pictograph?",
        "answers": [
          { "text": "It shows what each picture or symbol stands for", "correct": true },
          { "text": "It tells you the title of the graph", "correct": false },
          { "text": "It counts how many pictures there are", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Why are pictographs easy to read?",
        "answers": [
          { "text": "Because they use pictures to show information", "correct": true },
          { "text": "Because they only show numbers", "correct": false },
          { "text": "Because they use no labels", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does a pictograph use to display data?",
        "answers": [
          { "text": "Pictures and symbols", "correct": true },
          { "text": "Lines and shapes", "correct": false },
          { "text": "Words and sentences", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "2timestable",
    "title": "2 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "2 × 3 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "2 × 5 = ?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "8", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "2 × 7 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 9 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "20", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 12 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "3timestable",
    "title": "3 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "3 × 2 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "3 × 4 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "9", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "3 × 6 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "15", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "3 × 8 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "27", "correct": false },
          { "text": "21", "correct": false }
        ]
      },
      {
        "question": "3 × 12 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "30", "correct": false },
          { "text": "33", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "4timestable",
    "title": "4 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "4 × 3 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "8", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 5 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "24", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 7 = ?",
        "answers": [
          { "text": "28", "correct": true },
          { "text": "24", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "4 × 9 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "40", "correct": false }
        ]
      },
      {
        "question": "4 × 12 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "44", "correct": false },
          { "text": "42", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "5timestable",
    "title": "5 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "5 × 3 = ?",
        "answers": [
          { "text": "15", "correct": true },
          { "text": "10", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "5 × 4 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "5 × 6 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "25", "correct": false },
          { "text": "35", "correct": false }
        ]
      },
      {
        "question": "5 × 8 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "35", "correct": false },
          { "text": "45", "correct": false }
        ]
      },
      {
        "question": "5 × 12 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "55", "correct": false },
          { "text": "65", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "6timestable",
    "title": "6 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "6 × 3 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "12", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "6 × 4 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "18", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "6 × 5 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "24", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 7 = ?",
        "answers": [
          { "text": "42", "correct": true },
          { "text": "48", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 9 = ?",
        "answers": [
          { "text": "54", "correct": true },
          { "text": "60", "correct": false },
          { "text": "48", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "7timestable",
    "title": "7 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "7 × 2 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "7 × 3 = ?",
        "answers": [
          { "text": "21", "correct": true },
          { "text": "24", "correct": false },
          { "text": "18", "correct": false }
        ]
      },
      {
        "question": "7 × 5 = ?",
        "answers": [
          { "text": "35", "correct": true },
          { "text": "28", "correct": false },
          { "text": "42", "correct": false }
        ]
      },
      {
        "question": "7 × 8 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "63", "correct": false },
          { "text": "49", "correct": false }
        ]
      },
      {
        "question": "7 × 12 = ?",
        "answers": [
          { "text": "84", "correct": true },
          { "text": "77", "correct": false },
          { "text": "91", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "8timestable",
    "title": "8 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "8 × 2 = ?",
        "answers": [
          { "text": "16", "correct": true },
          { "text": "18", "correct": false },
          { "text": "14", "correct": false }
        ]
      },
      {
        "question": "8 × 3 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "28", "correct": false },
          { "text": "32", "correct": false }
        ]
      },
      {
        "question": "8 × 5 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "48", "correct": false },
          { "text": "56", "correct": false }
        ]
      },
      {
        "question": "8 × 7 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "64", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "8 × 12 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "88", "correct": false },
          { "text": "104", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "9timestable",
    "title": "9 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "9 × 2 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "16", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "9 × 4 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "27", "correct": false }
        ]
      },
      {
        "question": "9 × 5 = ?",
        "answers": [
          { "text": "45", "correct": true },
          { "text": "40", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 7 = ?",
        "answers": [
          { "text": "63", "correct": true },
          { "text": "72", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 12 = ?",
        "answers": [
          { "text": "108", "correct": true },
          { "text": "99", "correct": false },
          { "text": "112", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "10timestable",
    "title": "10 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "10 × 2 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "10", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "10 × 4 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "30", "correct": false },
          { "text": "50", "correct": false }
        ]
      },
      {
        "question": "10 × 6 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "50", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "10 × 8 = ?",
        "answers": [
          { "text": "80", "correct": true },
          { "text": "70", "correct": false },
          { "text": "90", "correct": false }
        ]
      },
      {
        "question": "10 × 12 = ?",
        "answers": [
          { "text": "120", "correct": true },
          { "text": "100", "correct": false },
          { "text": "110", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "11timestable",
    "title": "11 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "11 × 2 = ?",
        "answers": [
          { "text": "22", "correct": true },
          { "text": "21", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "11 × 4 = ?",
        "answers": [
          { "text": "44", "correct": true },
          { "text": "42", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "11 × 6 = ?",
        "answers": [
          { "text": "66", "correct": true },
          { "text": "64", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "11 × 8 = ?",
        "answers": [
          { "text": "88", "correct": true },
          { "text": "80", "correct": false },
          { "text": "99", "correct": false }
        ]
      },
      {
        "question": "11 × 12 = ?",
        "answers": [
          { "text": "132", "correct": true },
          { "text": "121", "correct": false },
          { "text": "142", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "12timestable",
    "title": "12 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "12 × 2 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      },
      {
        "question": "12 × 4 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "42", "correct": false },
          { "text": "52", "correct": false }
        ]
      },
      {
        "question": "12 × 6 = ?",
        "answers": [
          { "text": "72", "correct": true },
          { "text": "68", "correct": false },
          { "text": "78", "correct": false }
        ]
      },
      {
        "question": "12 × 8 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "92", "correct": false },
          { "text": "100", "correct": false }
        ]
      },
      {
        "question": "12 × 12 = ?",
        "answers": [
          { "text": "144", "correct": true },
          { "text": "132", "correct": false },
          { "text": "156", "correct": false }
        ]
      }
    ]
  }, 
  
]

export default va3rdMathQuizContent;
